import { format, getDate, getMonth, getYear, parse, startOfDay, setMonth, getHours, getMinutes } from 'date-fns';
import trLocale from 'date-fns/locale/tr';

const javaTimeFormat = "yyyy-MM-dd'T'HH:mm:ss.SSS";
const javaTimeFormatGTM = "yyyy-MM-dd'T'HH:mm:ss";
const cgTimeFormat = "yyyy-MM-dd'T'HH:mm";

/**
 * @param {*} date
 * @date    : Tue Jun 25 2019 15:24:48 GMT+0300 (GMT+03:00)
 * @returns : '2019-06-25T15:24:48.000'
 */
export const dateToJavaTimeConverter = date => {
  date = !date ? new Date() : new Date(date);

  return format(startOfDay(date), javaTimeFormat);
};

export const dateToJavaTimeConverterGTM = date => {
  date = !date ? new Date() : new Date(date);

  return format(date, javaTimeFormatGTM);
};

export const getMonthName = value => typeof value === 'number' ? format(
  setMonth(new Date(), value), 'MMM', {
    locale: trLocale
  }) : '';

export const getFullMonthName = value => typeof value === 'number' ? format(
  setMonth(new Date(), value), 'MMMM', {
    locale: trLocale
  }) : '';

// This func accepts date type: 2019-07-28T00:00:00.000
export const splitDate = value => {
  const date = parse(value, javaTimeFormat, new Date());

  return {
    day: getDate(date),
    month: getMonth(date),
    year: getYear(date)
  };
};

export const cgCouponsDateFormatter = (value, withGTM) => {
  if (value && isNaN(value)) {
    const formatter = withGTM ? javaTimeFormatGTM : cgTimeFormat;
    const date = parse(value, formatter, new Date());

    let hoursInfo = '';
    
    if (withGTM) {
      let hours = getHours(date) < 10 ? `0${getHours(date)}` : getHours(date);
      let minutes = getMinutes(date) < 10 ? `0${getMinutes(date)}` : getMinutes(date);

      hoursInfo = `${hours}:${minutes}`;
    }

    return `${getDate(date)} ${getFullMonthName(getMonth(date))} ${getYear(date)} ${hoursInfo}`;
  }
};

export const cgDrawDateFormatter = value => {
  if (value && isNaN(value)) {
    const date = parse(value, cgTimeFormat, new Date());

    return `${getDate(date)} ${getFullMonthName(getMonth(date))} ${getYear(date)}`;
  }
};

export const getHoursMinutes = (value, dateFormat = javaTimeFormat) => {
  const date = parse(value, dateFormat, new Date());

  return format(date, 'HH:mm');
};

export const getTodayInfo = () => {
  return format(new Date(), 'd MMMM', { locale: trLocale });
};

export const getPassedYears = date => {
  return getYear(new Date()) - getYear(new Date(date));
};

export const getFormattedDate = date => {
  return format(new Date(date), 'd MMMM yyyy', { locale: trLocale });
};
